import { GOAL_TIER_IDS, MAX_GOALS_PROFILE, emptyGoalTiers } from '../constants/goalTiers';

export function parseGoalTiers(raw) {
  if (!raw || typeof raw !== 'object' || Array.isArray(raw)) return emptyGoalTiers();
  const out = emptyGoalTiers();
  for (const id of GOAL_TIER_IDS) {
    out[id] = Array.isArray(raw[id])
      ? [...new Set(raw[id].map((s) => String(s).trim().toLowerCase()).filter(Boolean))]
      : [];
  }
  return out;
}

export function flattenGoalTiers(tiers) {
  const parsed = parseGoalTiers(tiers);
  const out = [];
  const seen = new Set();
  for (const id of GOAL_TIER_IDS) {
    for (const slug of parsed[id]) {
      if (!slug || seen.has(slug)) continue;
      seen.add(slug);
      out.push(slug);
    }
  }
  return out;
}

export function countGoalTiers(tiers) {
  return flattenGoalTiers(tiers).length;
}

export function toggleGoalInTier(tiers, tierId, slug, max = MAX_GOALS_PROFILE) {
  const parsed = parseGoalTiers(tiers);
  const normalized = String(slug || '').trim().toLowerCase();
  if (!normalized || !GOAL_TIER_IDS.includes(tierId)) return parsed;

  const hasInTier = parsed[tierId].includes(normalized);
  if (hasInTier) {
    parsed[tierId] = parsed[tierId].filter((s) => s !== normalized);
    return parsed;
  }

  if (countGoalTiers(parsed) >= max) return parsed;

  for (const id of GOAL_TIER_IDS) {
    parsed[id] = parsed[id].filter((s) => s !== normalized);
  }
  parsed[tierId] = [...parsed[tierId], normalized];
  return parsed;
}

export function removeGoalFromTier(tiers, tierId, slug) {
  const parsed = parseGoalTiers(tiers);
  const normalized = String(slug || '').trim().toLowerCase();
  if (!GOAL_TIER_IDS.includes(tierId)) return parsed;
  parsed[tierId] = parsed[tierId].filter((s) => s !== normalized);
  return parsed;
}

export function readGoalTiersFromUser(user) {
  if (user?.trainingGoalTiers) {
    const parsed = parseGoalTiers(user.trainingGoalTiers);
    if (countGoalTiers(parsed) > 0) return parsed;
  }
  const slugs = Array.isArray(user?.trainingGoalSlugs)
    ? user.trainingGoalSlugs
    : user?.goal
      ? [user.goal]
      : ['hipertrofia'];
  return { essential: [...slugs], support: [], context: [] };
}

export function syncGoalSlugsFromTiers(tiers) {
  return flattenGoalTiers(tiers);
}
